import { useContext } from 'react'

import SearchPageContext from '@contexts/searchPageContext'

const useIsOnSearchPage = (): boolean => !!useContext(SearchPageContext)

export default useIsOnSearchPage
